import React from 'react';
import { DataLoaderProps } from '../types';

const RedaxoLoader: React.FC<DataLoaderProps> = () => {
    return (
        <div>
            <div style={{ marginTop: '20px', marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '18px', color: '#495057' }}>
                    Daten aus Redaxo laden
                </h3>
                
                <p style={{ color: '#6c757d' }}>
                    Diese Funktion ist noch nicht verfügbar.
                </p>
            </div>
        </div>
    );
};

export default RedaxoLoader;
